import { useEffect, useState } from "react";
import { BasicButton } from "../../../../theme/Component/BasicButton";
import { InputMoney } from "../../../../theme/Input/InputMoney";
import { _RequestCredit, _single } from "../../../../../core/services/dataBean/EntityCatalog";
import { MASK_MONEY } from "../../../../theme/Component/BasicTable";
import { CreditDetails } from "./Components/CreditDetails";
import useModal, { MODAL_md, MODAL_XL } from "../../../../theme/Component/hooks/useModal";
import { Modal } from "../../../../theme/Component/Modal";
import { AccountEditor } from "../../../../editor/AccountEditor";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { toast } from "react-toastify";
import { PrintJson } from "../../../../theme/Component/PrintJson";
import { SelectCreditRoleGroup } from "../../../../erp/CreditRoleGroup/SelectCreditRoleGroup";

interface ProcedureFunctions {
    _exportMap: Function;
    _procedure: any;
    _pocessData?: any;
    _pushInfo?: Function;
    _pushProps?: Function;
}

interface Props {
    configProcedure: ProcedureFunctions;
}

interface Resp {
    Obs: string;
    Approve: string;
}

export const CC006 = ({ configProcedure }: Props) => {
    const { instance, bean, setBean } = useDataBean(_RequestCredit);

    const [response, setResponse] = useState<Resp>({
        Approve: "",
        Obs: "",
    })

    const [props, setProps] = useState<any>({})

    useEffect(() => {
        if (configProcedure?._pocessData?.Props) {
            const x = configProcedure?._pocessData?.Props
            setProps(x)
        }
        getReuqest();
    }, [configProcedure?._pocessData])

    const onExportMap = () => {

        if (configProcedure?._pushInfo) {
            configProcedure?._pushInfo(response.Obs)
        }

        if (configProcedure?._pushProps) {
            configProcedure?._pushProps({ ObsAnalist: response.Obs, ApproveAnalist: response.Approve })
        }

        if (configProcedure?._exportMap) {
            configProcedure?._exportMap(response)
        }

    }

    useEffect(() => {
        if (response.Approve !== "") {
            onExportMap();
        }
    }, [response]);

    const updateForm = (app: string) => {
        setResponse(prev => ({ ...prev, Approve: app }));
    }

    const getReuqest = () => {
        const props = {
            IDProcedureImp: configProcedure._procedure.IDProcedureImp
        }
        instance.getRequestCreditCatalogPorPropiedades(props, null).then(
            (resp) => {
                console.log(resp[0].DataBeanProperties)
                setBean(resp[0].DataBeanProperties)
            }
        ).catch(err => {
            toast.error(err)
        })
    }

    const modalAmortizacion = useModal("Informacion del Credito", MODAL_XL);

    return (
        <>
            <div className="row d-flex justify-content-between">
                <div className="col-md-4 ">
                    <div className="row">
                        <div className="col-md-12 d-flex justify-content-between align-items-center">
                            <strong>Valor Solicitado:</strong>
                            <div dangerouslySetInnerHTML={{ __html: _single.formatFieldMask(bean?.AmountCredit ?? 0, MASK_MONEY) }}></div>
                        </div>
                        <div className="col-md-12 d-flex justify-content-between align-items-center">
                            <strong>Valor Aprobado:</strong>
                            <div dangerouslySetInnerHTML={{ __html: _single.formatFieldMask(bean?.AmountApprove ?? 0, MASK_MONEY) }}></div>
                        </div>
                        <div className="col-md-12 d-flex justify-content-between align-items-center">
                            <strong>Cuotas:</strong>
                            <div dangerouslySetInnerHTML={{ __html: bean.Cuotes }}></div>
                        </div>
                        <div className="col-md-12 d-flex justify-content-between align-items-center">
                            <strong>Procentaje:</strong>
                            <div dangerouslySetInnerHTML={{ __html: `%${bean.AmountTax}` }}></div>
                        </div>
                    </div>
                </div>

                <div className="col-md-4 text-end mt-3">
                    <BasicButton
                        icon="ri-arrow-down-s-line"
                        eventClick={() => modalAmortizacion.open()}
                    >
                        Ver más
                    </BasicButton>
                </div>

                <div className="col-md-12">
                    <label>Observaciones (Visibles para el Afiliado)</label>
                    <textarea rows={6} className="form-control" value={response.Obs} onChange={(e) => { setResponse({ ...response, "Obs": e.target.value }) }} />
                </div>

                <div className="col-md-4 position-relative">
                    <BasicButton icon="ri-checkbox-circle-line" eventClick={() => { updateForm("true") }} >Aprobar</BasicButton>
                </div>

                <div className="col-md-4 d-flex justify-content-end position-relative">
                    <BasicButton icon="ri-close-circle-line" eventClick={() => { updateForm("false") }} >Archivar</BasicButton>
                </div>


                <div className="col-md-12">

                    <Modal modal={modalAmortizacion.modal} updateModal={modalAmortizacion.setModal} >
                        <div className="col-md-12 mt-3">
                            <CreditDetails
                                objectUpdate={bean}
                                onUpdate={() => { getReuqest(); }}
                                Props={{
                                    Codeudor: bean.JSONCodeuda ? JSON.parse(bean.JSONCodeuda) : {},
                                    Credito: bean.JSONCredit ? JSON.parse(bean.JSONCredit) : {},
                                    Notas: bean.JSONNotes ? JSON.parse(bean.JSONNotes) : {},
                                    CheckList: bean.JSONCheckList ? JSON.parse(bean.JSONCheckList) : {},
                                    RProps: props
                                }}
                            />
                        </div>
                    </Modal>
                </div>
            </div>
        </>
    );
};